import styles from './FJArcProgress.module.less';
import LoadingBK from '../../../assets/svg/transcribe/loading-bg.svg?react';
import { useEffect, useRef } from 'react';
import classNames from 'classnames';
function FJArcProgress(props) {
    const {
        showBackground = false,
        boxClassName,
        percent,
        valueClassName,
        fractionDigits = 1,
        isShowPercent = true,
        size = 100,
    } = props;
    const progressRef = useRef(null);
    let progress = Math.min(100, percent * 100);

    useEffect(() => {
        progressRef.current.style.setProperty('--percent', progress);
    }, [progress]);

    return (
        <div
            className={classNames(styles.progress_circle, boxClassName)}
            style={{
                '--size': `${size}px`,
            }}
            ref={progressRef}
        >
            {showBackground && <LoadingBK className={styles.bk} />}
            <svg>
                <defs>
                    <linearGradient
                        x1='12.801967%'
                        y1='9.38353516%'
                        x2='87.198033%'
                        y2='100%'
                        id='FJArcProgress-gradient'
                    >
                        <stop stopColor='#FF47D0' offset='0%'></stop>
                        <stop stopColor='#FF822C' offset='100%'></stop>
                    </linearGradient>
                </defs>
                <circle className={styles.circle_bottom} stroke='var(--inactive-color)' />
                <circle className={styles.circle_top} stroke='url(#FJArcProgress-gradient)' />
            </svg>
            {isShowPercent ? (
                <div className={classNames(styles.circle_text, valueClassName)}>
                    {(Math.floor(progress * 10) / 10).toFixed(fractionDigits)}%
                </div>
            ) : null}
        </div>
    );
}

export default FJArcProgress;
